// https://github.com/AzureAD/microsoft-authentication-library-for-js/issues/521#issuecomment-577400515
import { Configuration, LogLevel } from '@azure/msal-browser';
import config from '@config/index';
import { isSafari } from '@shared/hooks';

export const msalConfig: Configuration = {
  auth: {
    clientId: config.MS_CLIENT_ID,
    authority: 'https://login.microsoftonline.com/common', // 86f69356-804c-417f-9db8-992ae2ed0649,  // tenant
    redirectUri: window.location.origin, // + '/auth'
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: isIE() || isSafari(), // Conditional use based on browser type; function to detect IE browser
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (!containsPii) {
          switch (level) {
            case LogLevel.Error:
              console.error(message);
              break;
            case LogLevel.Info:
              // console.info(message);
              break;
            case LogLevel.Verbose:
              // console.debug(message);
              break;
            case LogLevel.Warning:
              console.warn(message);
              break;
          }
        }
      },
    },
  },
};

// Helper function to determine if the browser is Internet Explorer
function isIE() {
  const ua = window.navigator.userAgent;
  const msie = ua.indexOf('MSIE ');
  const msie11 = ua.indexOf('Trident/');
  return msie > 0 || msie11 > 0;
}
